import React from 'react';
import { motion } from 'framer-motion';
import { Star, BookOpen } from 'lucide-react';
export function HeroSection() {
  return <section className="pt-16 pb-10 md:pt-24 md:pb-16 px-4 overflow-hidden" data-id="element-78">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-8 items-center" data-id="element-79">
        {/* Text Content */}
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6
      }} className="flex flex-col items-start" data-id="element-80">
          <div className="inline-flex items-center gap-2 bg-gold-500/20 text-gold-700 px-4 py-1.5 rounded-full text-sm font-bold mb-4 border border-gold-500/30" data-id="element-81">
            <BookOpen className="w-4 h-4" data-id="element-82" />
            GUÍA DIGITAL
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-4 text-espresso-900" data-id="element-83">
            Aprende el arte de preparar{' '}
            <span className="text-gold-600 italic" data-id="element-84">café profesional</span> desde
            tu casa{' '}
            <u className="decoration-gold-500 decoration-2 underline-offset-4" data-id="element-85">
              en menos de una semana.
            </u>
          </h1>

          <p className="text-xl md:text-2xl text-espresso-800 mb-6 font-medium" data-id="element-86">
            <strong data-id="element-87">Más de 500 recetas</strong> paso a paso
          </p>

          <div className="flex items-center gap-2 mb-6 bg-cream-200 px-4 py-2 rounded-lg" data-id="element-88">
            <div className="flex text-gold-500" data-id="element-89">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-90" />)}
            </div>
            <span className="font-bold text-espresso-900" data-id="element-91">4.8/5</span>
            <span className="text-espresso-700 text-sm" data-id="element-92">(+2,000 lectores)</span>
          </div>

          <a href="https://elartedelcafe.online/cart/add?id=57377971798341&quantity=1" className="w-full sm:w-auto bg-cta-600 hover:bg-cta-800 text-white text-lg md:text-xl font-bold py-4 px-8 rounded-xl shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1 text-center flex items-center justify-center gap-2" data-id="element-93">
            <span className="text-2xl" data-id="element-94"></span> Agregar al carrito
          </a>

          <p className="mt-3 text-sm text-espresso-700 flex items-center gap-2" data-id="element-95">
            <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse" data-id="element-96"></span>
            <strong data-id="element-97">Acceso inmediato</strong> tras la compra
          </p>
        </motion.div>

        {/* Book Image */}
        <motion.div initial={{
        opacity: 0,
        x: 30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="relative" data-id="element-98">
          <div className="absolute inset-0 bg-gold-500/20 blur-3xl rounded-full transform -rotate-6 scale-105" data-id="element-99"></div>
          <div className="relative max-w-sm mx-auto flex flex-col items-center text-center" data-id="element-100">
            <img src="https://cdn.magicpatterns.com/uploads/hYo6CP8csFeSZDfSppn3bL/20260312_1033_Image_Generation_remix_01kkh3yer1f6vbc3zvvk8zjamn.png" alt="El Arte del Café - Libro Digital" className="w-full rounded-2xl shadow-2xl object-cover" data-id="element-101" />
            <h3 className="font-serif text-2xl font-bold text-espresso-900 mt-4" data-id="element-102">
              El Arte del Café
            </h3>
          </div>
        </motion.div>
      </div>
    </section>;
}